import { useStateMachine } from "little-state-machine"
import { useIntl } from "react-intl"
import { updateAction } from "utils/littleStateMachine"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm, useWatch } from "react-hook-form"
import { VALIDATION_MESSAGES } from "utils/forms"
import InputTextArea from "components/InputMUI/TextArea"
import { BASIC_BOOLEAN_OPTIONS, GENERIC_MSGS } from "modules/claims/constants"
import { BUTTON_MESSAGES } from "utils/buttons"
import ProgressBar from "modules/claims/components/StepForm/ProgressBar"
import RadioButton from "components/InputMUI/RadioButton"
import Select from "components/InputMUI/Select"
import { ADEQUATE_PRODUCT_RESISTANCE_OPTIONS, MATERIAL_RESISTANCE_MSGS } from "./constants"
import { useNavigate } from "react-router-dom"
import { redirectToNextStep } from "../../../utils"

const MaterialResistance = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction })

  const defaultValues = { ...state }
  const schema = yup.object({
    adequateProductResistance: yup
      .string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    knowTheRecomendations: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    howDetectedNonConformity: yup
      .string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    howItTransforms: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required))
  })

  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const adequateProductResistanceValue = useWatch({ control, name: "adequateProductResistance" })

  const onSubmit = (data) => {
    actions.updateAction(data)
    redirectToNextStep(navigate)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Select
        name="adequateProductResistance"
        control={control}
        label={MATERIAL_RESISTANCE_MSGS.adequateProductResistance}
        placeholder={GENERIC_MSGS.choose_placeholder}
        options={ADEQUATE_PRODUCT_RESISTANCE_OPTIONS}
        defaultValue={state.adequateProductResistance}
        error={errors.adequateProductResistance?.message}
      />
      {adequateProductResistanceValue === "other" && (
        <InputTextArea
          name="ifOtherDescription"
          control={control}
          label={MATERIAL_RESISTANCE_MSGS.ifOtherDescription}
          placeholder={GENERIC_MSGS.typeAnswer_placeholder}
          defaultValue={state.ifOtherDescription}
          error={errors.ifOtherDescription?.message}
        />
      )}
      <RadioButton
        name="knowTheRecomendations"
        register={register}
        label={MATERIAL_RESISTANCE_MSGS.knowTheRecomendations}
        options={BASIC_BOOLEAN_OPTIONS}
        defaultValue={state.knowTheRecomendations}
        error={errors.knowTheRecomendations?.message}
      />
      <InputTextArea
        name="howDetectedNonConformity"
        control={control}
        label={MATERIAL_RESISTANCE_MSGS.howDetectedNonConformity}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.howDetectedNonConformity}
        error={errors.howDetectedNonConformity?.message}
      />
      <InputTextArea
        name="howItTransforms"
        control={control}
        label={MATERIAL_RESISTANCE_MSGS.howItTransforms}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.howItTransforms}
        error={errors.howItTransforms?.message}
      />
      <div className="btn-container">
        <button className="btn btn-dark" type="submit">
          {intl.formatMessage(BUTTON_MESSAGES.ok)}
        </button>
      </div>
      <ProgressBar
        progress={60}
        handleNext={handleSubmit(onSubmit)}
        RoutePrev={state.previousStep}
      />
    </form>
  )
}

export default MaterialResistance
